import { ExclamationCircleOutlined } from "@ant-design/icons";
import ErrorView from "~components/Error";

const NotFoundPage = () => (
  <ErrorView
    titleIntlKey="error.page.not.found"
    descriptionIntlKey="error.page.not.found.description"
    actionButtonIntlKey="go.back"
    Icon={ExclamationCircleOutlined}
  />
);

export default NotFoundPage;
